import { Modal, Button } from 'antd';

const UploadConfirmationModal = ({ visible, onClose, onUploadToCatalog, videoPreview }) => {
  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      width={400}
      className="upload-confirmation-modal"
      centered
    >
      <div className="text-center">
        <div className="relative w-72 h-72 mx-auto mb-6 rounded-lg overflow-hidden">
          <video
            src={videoPreview}
            className="w-full h-full object-cover"
            autoPlay
            muted
            loop
            playsInline
          />
          {/* <div className="absolute inset-0 flex items-center justify-center">
            <div className="h-16 w-16 bg-black bg-opacity-50 rounded-full flex items-center justify-center">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                <path d="M5 3L19 12L5 21V3Z" fill="white"/>
              </svg>
            </div>
          </div> */}
        </div>

        <h2 className="text-2xl font-medium mb-8">
          Do you want to upload this video to the catalog?
        </h2>

        <div className="flex gap-4 justify-center w-full">
          <Button
            size="large"
            className="h-12 flex-1 rounded-2xl bg-gray-100 border-0 text-gray-900"
            onClick={onClose}
          >
            Not Now
          </Button>
          <Button
            size="large"
            type="primary"
            className="h-12 flex-1 rounded-2xl bg-gray-900 border-0 text-white flex items-center justify-center gap-2"
            onClick={onUploadToCatalog}
          >
            Upload to Catalogue
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default UploadConfirmationModal;